// Компонент принимает тип const enum STATUS пример использования => <StatusType roles={[STATUS.TO_REWORK]}>
import React, { PropsWithChildren } from "react";
import { ApplicationBankGuardStatus, ApplicationBankStatus } from "./types";
import { getStatusesWithoutDisabled, isStatusAllowed } from "./helpers";

// Вспомогательный интерфейс для разрешенных статусов
interface allowApplicationBankStatusGuard {
  allowedStatuses: ApplicationBankGuardStatus[];
  disabledStatuses?: never;
}
// Вспомогательный интерфейс для запрещенных статусов
interface disableApplicationBankStatusGuard {
  disabledStatuses: ApplicationBankGuardStatus[];
  allowedStatuses?: never;
}
/**Тип пропсов для проверки статуса
 * Можно передавать только разрешенные или только запрещенные статусы
 */
type ApplicationBankStatusGuardProps = {
  status: ApplicationBankStatus | undefined;
} & (allowApplicationBankStatusGuard | disableApplicationBankStatusGuard);

/** Guard по статусам заявок в банк. Проверяет "название банка" и "статус" заявки в банк.
 *  Возможно передавать только разрешенные или только запрещенные статусы
 * @param status - Статус заявки в банк
 * @param allowedStatuses - Список разрешенных статусов
 * @param disabledStatuses - Список запрещенных статусов
 */
export const ApplicationBankStatusGuard = ({
  children,
  status,
  allowedStatuses,
  disabledStatuses,
}: PropsWithChildren<ApplicationBankStatusGuardProps>) => {
  if (!status) {
    return null;
  }
  if (allowedStatuses && isStatusAllowed(status, allowedStatuses)) {
    return <>{children}</>;
  }
  if (
    disabledStatuses &&
    isStatusAllowed(status, getStatusesWithoutDisabled(disabledStatuses))
  ) {
    return <>{children}</>;
  }

  return null;
};
